import { defineStore } from 'pinia'

import { useStorage } from '@vueuse/core'

import type { ZIncidentListItemIncident } from '@tsyl/zapan2/lib/types/ZIncidentListItem'

export const incidentsPinnedStore = defineStore('incidentsPinned', () => {
  const pinned = useStorage('incidentsPinned', [] as Array<ZIncidentListItemIncident>)
  return { pinned }
})
